import React, {useState} from "react";

import {useFetch} from "react-admin-base";
import {Link, Navigate, useParams} from "react-router-dom";
import {Button, Col, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import {FieldStatic} from "../../Components/Fields";

export function UserDetailButton({id}) {
    return <Button tag={Link} to={id + "/view"} className="ms-1" outline type="button" color="success">Detail</Button>;
}

export function UserDetailButtonModal({id}) {
    const [open, setOpen] = useState(false);

    return <>
        {open && <UserDetailModal id={id} onClose={_ => setOpen(false)}/>}
        <Button onClick={_ => setOpen(true)} className="ms-1" outline type="button" color="success">Detail</Button>
    </>;
}

export function UserDetailPage() {
    const {id} = useParams();
    const [open, setOpen] = useState(true);

    if (!open)
        return <Navigate to="/user" replace/>;

    return <UserDetailModal id={id} onClose={_ => setOpen(false)}/>;
}

function UserDetailModal({id, onClose}) {
    return <Modal size="lg" isOpen toggle={onClose}>
        <ModalHeader toggle={onClose}>
            User #{id}
        </ModalHeader>
        <ModalBody>
            <UserDetail id={id}/>
        </ModalBody>
    </Modal>
}

export function UserDetail({id, detail}) {
    const [user] = useFetch('/user/' + id);

    if (!user)
        return null;

    return <>
       <Row>
            <Col>
                <FieldStatic title="Name">
                    <div>
                        {user.name}
                    </div>
                </FieldStatic>
            </Col>
            <Col>
                <FieldStatic title="Email">
                    <div>
                        {user.email}
                    </div>
                </FieldStatic>
            </Col>
            <Col>
                <FieldStatic title="Phone">
                    <div>
                        {user.phone}
                    </div>
                </FieldStatic>
            </Col>
        </Row>
    </>;
}
